import { render, staticRenderFns } from "./CallData.vue?vue&type=template&id=1cc94baf&scoped=true"
import script from "./CallData.vue?vue&type=script&lang=js"
export * from "./CallData.vue?vue&type=script&lang=js"
import style0 from "./CallData.vue?vue&type=style&index=0&id=1cc94baf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc94baf",
  null
  
)

export default component.exports